import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataApiResponseLegacy, Seat } from '@digilize/shared/definitions/src';
import { SeatType } from '@digilize/shared/definitions/src';

@Injectable({
  providedIn: 'root',
})
export class SeatsApiService {
  readonly seatsBaseUrl = '/api/v1.0/seats';
  readonly seatTypesBaseUrl = '/api/v1.0/seats/types';
  constructor(private http: HttpClient) {}

  addSeat(seat) {
    return this.http.post(`${this.seatTypesBaseUrl}`, seat);
  }

  updateSeat(seat) {
    return this.http.put(`${this.seatTypesBaseUrl}`, seat);
  }

  cloneSeat(seat) {
    return this.http.post<SeatType>(`${this.seatTypesBaseUrl}/clone`, seat);
  }

  getSeatTypes(queryParams) {
    return this.http.get<DataApiResponseLegacy<SeatType[]>>(`${this.seatTypesBaseUrl}`, { params: queryParams });
  }

  getSeat(id: string) {
    return this.http.get<SeatType>(`${this.seatTypesBaseUrl}/${id}`);
  }

  getAreaAssignedSeats(params) {
    return this.http.get<DataApiResponseLegacy<Seat[]>>(`${this.seatsBaseUrl}`, { params });
  }

  removeSeat(id: string) {
    return this.http.delete(`${this.seatTypesBaseUrl}/${id}`);
  }
}
